import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  List,
  Box,
  Tooltip,
} from '@mui/material';
import {
  Build as BuildIcon,
  ExpandLess,
  ExpandMore,
  QueryStats as QueryStatsIcon,
  SyncAlt as SyncAltIcon,
  FactCheck as FactCheckIcon,
  MoreHoriz as MoreIcon,
} from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';

// Maintenance submenu — diagnostics/admin pages. API Usage is admin-only;
// Sync Log and Recon Issues are standalone pages; the remaining one-off
// operations (earnings update, balance snapshot) live on the "Other" page.
const MaintenanceMenu = ({ collapsed = false, onExpand }) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { user } = useAuth();

  const handleClick = () => {
    // Collapsed rail has no room for the submenu — expand first, then open.
    if (collapsed) {
      setOpen(true);
      onExpand?.();
      return;
    }
    setOpen(!open);
  };

  const maintenanceItems = [
    ...(user?.isAdmin ? [{ text: 'API Usage', icon: <QueryStatsIcon />, path: '/admin/api-usage' }] : []),
    { text: 'Sync Log', icon: <SyncAltIcon />, path: '/sync-logs' },
    { text: 'Recon Issues', icon: <FactCheckIcon />, path: '/recon-issues' },
    { text: 'Other', icon: <MoreIcon />, path: '/maintenance' },
  ];

  const isActive = maintenanceItems.some(item => location.pathname === item.path);

  return (
    <>
      <Tooltip title={collapsed ? 'Maintenance' : ''} placement="right" arrow>
        <ListItemButton
          onClick={handleClick}
          selected={isActive}
          sx={collapsed ? { justifyContent: 'center', px: 0.5 } : { px: 1 }}
        >
          <ListItemIcon sx={collapsed ? { minWidth: 0, justifyContent: 'center' } : { minWidth: 36 }}>
            <BuildIcon />
          </ListItemIcon>
          {!collapsed && <ListItemText primary="Maintenance" />}
          {!collapsed && (open ? <ExpandLess /> : <ExpandMore />)}
        </ListItemButton>
      </Tooltip>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {maintenanceItems.map((item) => (
            <ListItemButton
              key={item.text}
              component={Link}
              to={item.path}
              selected={location.pathname === item.path}
              sx={{ pl: 3, pr: 1 }}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>
                <Box sx={{ fontSize: '1.2rem' }}>
                  {item.icon}
                </Box>
              </ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </>
  );
};

export default MaintenanceMenu;
